var $j = jQuery.noConflict();

/* START: shorthand function for document.querySelector() */
let isFirst = true;

/**
 * @param {String} selector - e.g. #sampleId to select an element with id "sampleId"
*/

const qs = function (selector, parent = document) {
  return parent.querySelector(selector);
}
/* END */


/* START: shorthand function for document.querySelectorAll() */

/**
 * @param {String} selector - see above
*/


const qsa = function (selector, parent = document) {
  return [...parent.querySelectorAll(selector)];
}
/* END */


/* START: shorthand function for document.createElement() */

/**
 * @param {String} tagName
*/

const ce = function (tagName, parent = document) {
  return document.createElement(tagName);
}
/* END */


/** @type Element - inner-form-container is the left side of the filter menu that holds all of the options */
const inner_form = qs('.inner-form-container');

/* START: function to render suboptions, e.g. "10 µg RNA" under "Columns" */
/**
 * @param {Object} subOptionData - entire metadata for suboptions
 * @param {String} subOptionData.type - radio, checkbox, etc.
 * @param {String} subOptionData.child_name - class name for every input under the parent section
 * @param {Object[]} subOptionData.options - array of options
 * @param {String} subOptionData.options[].id - option ID
 * @param {String} subOptionData.options[].name - option label
 * @returns {String} DOM elements that represent suboptions
*/

const renderSubOptions = (subOptionData) => {
  let renderedElement = '';
  const { type, child_name, options: subOptions } = subOptionData;

  subOptions.forEach(option => {
    const { id, name } = option;
    renderedElement += `
      <li class="body-2 subtier_child">
        <input class="${child_name}" type="${type}" name="${type === "radio" ? child_name : id}" id="${id}">
        <label for="${id}">${name}</label>
      </li>
    `
  })

  return renderedElement;
}
/* END */


/* START: function to render all other options */

/**
 * @param {Object[]} options - array of option objects
 * @param {String} options[].id - option ID
 * @param {String} options[].name - option label
 * @param {Boolean} options[].default_option - boolean for whether option should be selected by default
 * @param {Object} options[].sub_option - boolean for whether option should be selected by default
 * @param {Object[]} options[].sub_option.options - array of options
 * @param {String} type - radio, checkbox, etc.
 * @param {String} child_name - class name for every input under the parent section
 * @param {String} tier_id - id of the section
 * @returns {String} DOM elements that represent all other options
*/

const render_options = (options, type, child_name, tier_id) => {
  let rendered_options = '';

  options.forEach(option => {
    const { id, name, default_option, sub_option } = option;
    if (!sub_option || sub_option.options.length === 0) {
      rendered_options += `
      <li class="body-2 ${default_option ? "checked" : ""}">
        <input class="${child_name}" type="${type}" name="${type === "radio" ? tier_id : id}" id="${id}" ${default_option ? "checked" : ""}>
        <label for="${id}">${name}</label>
      </li>
      `
    } else {
      rendered_options += `
        <li class="body-2 subtier-controller">
          <input class="${child_name}" type="${type}" name="${type === "radio" ? tier_id : id}" id="${id}" ${default_option ? "checked" : ""} data-subtier-controller="subtier_${id}">
          <label for="${id}">${name}</label>
        </li>
        <ul class="subtier" id="subtier_${id}">
          ${renderSubOptions(sub_option)}
        </ul>
      `
    }
  })

  return rendered_options;
}
/* END */


/* START: function to render side menu */

/**
 * @param {Object} schema - page_schema object
 * @param {Object[]} schema.tiers - array containing information for each section of filter menu
 * @param {String} schema.tiers[].name - label for parent section
 * @param {String} schema.tiers[].type - radio, checkbox, etc.
 * @param {String} schema.tiers[].id - id name for parent section
 * @param {String} schema.tiers[].class_name - class name for parent section
 * @param {String} schema.tiers[].child_name - class name for every input under parent section
 * @param {Boolean} schema.tiers[].collapsable - boolean indicating whether section is collapsable
 * @param {Array} schema.tiers[].options - array of options under parent section
*/
const renderMenu = (schema) => {
  /** @type string - string to append individual section HTML to */
  let containers = '';

  schema.tiers.forEach(tier => {
    const { name, type, id, class_name, child_name, collapsable, options } = tier;

    /** @type string - string that represents individual section HTML */
    let container = `
	    <div class="input-container ${id}" id="${id}-container">

	      <button type="button" class="header-container" id="${id}-container-button" onclick="matchDropdownWidth(id)" data-toggle="collapse" aria-expanded="false" data-target="#${id}" aria-controls="${id}">
	        <h2>${name} <span id="${id}-count"></span> </h2>

          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M21.3417 22.2477L19.96 23.6611L14.4331 18.0076L15.8149 16.5942L21.3417 22.2477Z" fill="black"></path>
            <path d="M19.9598 23.6614L18.5781 22.248L24.1049 16.5945L25.4866 18.0079L19.9598 23.6614Z" fill="black"></path>
          </svg>
	      </button>
	      <ul class="${type ? type : ''} collapse ${collapsable ? `collapse show` : ``} ${class_name ? class_name : ''} select-dropdown ${id}" id="${id}">
	        ${render_options(options, type, child_name, id)}
	      </ul>
	    </div>
	  `;

    containers += container;
  })

  inner_form.insertAdjacentHTML('beforeend', containers);
}
/* END */


/* START: set text for product count */
/** @type Element - the actual number of found products in bold */
const productCount = qs('.product-count');


/** @type Element - the text that follows the bolded number */
const productsFoundText = qs('.product-found');


/** @param {Number} n - number of found products */
const setProductCount = n => {
  productCount.textContent = n;

  if (n === 1) {
    productsFoundText.textContent = " product found"
  } else {
    productsFoundText.textContent = " products found"
  }
}
/* END */


/* START: if input is selected, add 'checked' class to apply styling */

/** @param {HTMLInputElement} filter - filter input element */
const check_if_selected = (filter) => {
  const classList = filter.parentElement.classList;
  const checked = filter.checked;
  console.log(filter.id)
  if (checked) {
    classList.add('checked')
    if(typeof mixPanelTrack === 'function'){
      console.log("mixPanelTrack filter Select")
      mixPanelTrack('filterPageClick', {'click': 'filter select', 'description': `${filter.id}`, 'version': '${filterPageVersion}' })
    }
  } else {
    classList.remove('checked');
    if(hasfilterPageCategory){
      if(savedFilters.indexOf(filter.id) >= 0){
        if(typeof mixPanelTrack === 'function'){
          mixPanelTrack('filterPageClick', {'click': 'saved filter deselect', 'description': `${filter.id}`, 'version': '${filterPageVersion}' })
          savedFilters.splice(savedFilters.indexOf(filter.id), 1);
        }
      }
      else{
        mixPanelTrack('filterPageClick', {'click': 'filter deselect', 'description': `${filter.id}`, 'version': '${filterPageVersion}' })
      }
    }
    else{
      if(typeof mixPanelTrack === 'function'){
        mixPanelTrack('filterPageClick', {'click': 'filter deselect', 'description': `${filter.id}`, 'version': '${filterPageVersion}' })
      }
    }

  }

  if(isFirst == false){
    if(document.getElementById('products-alt')){
      document.getElementsByClassName('products')[0].classList.remove('d-none');
      document.getElementById('products-alt').classList.add('d-none');
    }
    scrollToTargetAdjusted()
  }
}
/* END */


/* START: function to hide filters when they can't be paired with current selected filters */
/**
 * @param {Object} possibleCombos - this is a Set of possible combinations
 * @param {Boolean} showAll - boolean to indicate whether to show all options, such as when user resets all filters
 * @param {CallableFunction} animationCompleteCallbackFunction - optional callback function to run when animation is complete
*/
const hideFilters = (possibleCombos, showAll, animationCompleteCallbackFunction = null) => {
  const options = {
    duration: 300
  };

  if (animationCompleteCallbackFunction) {
    options.complete = animationCompleteCallbackFunction;
  }

  qsa('.inner-form-container input').forEach(input => {
    /** @type HTMLInputElement -  */
    const liElement = $j(input.parentElement)

    if (showAll) {
      $j(input).prop('disabled', false);
    } else if (!possibleCombos.has(input.id) && !input.checked) {
      console.log('show all')
      $j(input).prop('disabled', true);
    } else if (possibleCombos.has(input.id)) {
      $j(input).prop('disabled', false);
    }
  })
  if(typeof permaFilter !== 'undefined'){
    let permaArray = permaFilter.split(',');
    for(permaIndex in permaArray){
      document.getElementById(permaArray[permaIndex]).disabled = true;
      document.getElementById(permaArray[permaIndex]).parentElement.classList.remove('checked')
      document.getElementById(permaArray[permaIndex]).parentElement.classList.add('d-none');
    }
  }
}
/* END */



/* START: function to truncate card descriptions */
/**
 * @param {String} description - product card description
 * @returns {String} truncated card description
*/
const truncate = description => {
  var chars = 250;
  var newString = description;
  if (description.length > chars) {
    newString = description.substring(0, chars);
    if (newString.charAt(249) != " ") {
      if (description.charAt(250) != " ") {
        let str = description.substring(chars);
        newString = newString + str.split(" ").splice(0, 1).join(" ");
      }
    }
    if(newString.charAt(newString.length - 1) != '.' ){
      newString = newString + "..."
    }
  }
  return newString;
}
/* END */

/* START: function to generate placeholder image url based on product title if nav image doesn't exist */
/**
 * @param {String} navImage - navigation image url suffix, e.g. high_throughput_magbead_microbiomics
 * @param {String} title - title of product
 * @returns {String} placeholder image with product title or picture element using navigation image suffix
*/
const checkNavigationImage = (navImage, title, altText) => {
  let titleClean = title.replace(/<[^>]*>/g, '');
  if (navImage === "") {
    const placeholderQuery = title.replaceAll(' ', '+');
    return `
      <img class="product-card__nav-image" src="https://via.placeholder.com/450x200.png?text=${placeholderQuery}" alt="placeholder">
    `
  } else if (navImage.includes('http')) {
    return `

      <img class="product-card__nav-image lazyload" src="${navImage}" alt="${altText == null ? title : altText}">
    `;
  }

  return `
    <picture>
      <source type="image/webp"
        data-srcset="https://files.zymoresearch.com/images/responsive_images/small/navigation_image_${navImage}.webp">
      <img width="480" height="200" class="product-card__nav-image lazyload"
        data-src="https://files.zymoresearch.com/images/responsive_images/medium/navigation_image_${navImage}.jpg" alt="${titleClean}">
    </picture>
  `;
}
/* END */

/* START: function to template-ize product card */
/**
 * @param {Object} product - each individual product object in schema file
 * @param {String} product.title - name of product
 * @param {String} product.catalogNumbers - product's catalog numbers
 * @param {String} product.description - product's description
 * @param {String} product.handle - product's handle
 * @param {String} product.image_url - product's image url (the image of the yellow box)
 * @param {String} product.navigation_image - product's navigation image url (the image at the top of the card)
 * @param {String[]} product.tags - array of product's tags
 * @returns {String} string representing product card HTML
*/
const cardTemplate = (product) => {
  // console.log(product)
  const { title, catalogNumbers, description, handle, image_url, navigation_image, tags, altText, id } = product;
  let titleClean = title.replace(/<[^>]*>/g, '');
  let productCard = ``;
  let isFreeSample = tags.includes('free-sample');
  if(navigation_image != ''){
    $j('.products-no-image').remove();
    productCard = `
    <div class="product-card" id="${titleClean}" style="position: relative;">
        <a href="${handle}" rel="noopener noreferrer"
        onclick="mixPanelTrack('filterPageClick', {'click': 'Product Card', 'description': '${titleClean}', 'destination': '${handle}', 'version': '${filterPageVersion}' })">
        ${isFreeSample ? `<div class="ribbon ribbon-yellow ribbon-top-left"><span>Free Sample</span></div>` : ''}
        ${checkNavigationImage(navigation_image, title, altText)}
        <h4 class="product-card__title" style="font-size: 16px; color: #21262B; font-family: 'Noto Sans';">${title}</h4>
        <div class="product-card__body pt-2">
            <div>
                <p class="body-3" style="font-size: 15px; font-family: 'Noto Sans';">${description == "" ? (allValueProps[id] ? allValueProps[id].meta_description : truncate(description)) : truncate(description)}</p>
            </div>
        </div>
        </a>
        <p class="product-card__catalog-numbers" style="style="font-family: 'Noto Sans';">${catalogNumbers}</p>
    </div>
    `;
  }
  else{
    $j('.products').remove();
    productCard = `
    <div class="product-card" id="${titleClean}">
        <a href="${handle}" rel="noopener noreferrer"
        onclick="mixPanelTrack('filterPageClick', {'click': 'Product Card', 'description': '${titleClean}', 'destination': '${handle}' })">
        ${tags.includes('accessories') && !tags.includes('free-sample') ? `<div class="ribbon ribbon-top-left"><span>Accessory</span></div>` : ''}
        ${!tags.includes('accessories') && tags.includes('free-sample') ? `<div class="ribbon ribbon-yellow ribbon-top-left"><span>Free Sample</span></div>` : ''}
        ${tags.includes('accessories') && tags.includes('free-sample') ? `<div class="ribbon ribbon-top-left"><span>Accessory</span></div> <div class="ribbon ribbon-yellow ribbon-top-right"><span>Free Sample</span></div>` : ''}
        <div class="product-card__header__no-image">
        <h4 class="product-card__title__no-image">${title}</h4>
        <p class="product-card__catalog-numbers__no-image">${catalogNumbers}</p>
        </div>
        <div class="product-card__body">
            <div>
                <p class="body-3__no-image">${truncate(description)}</p>
            </div>
        </div>
        </a>
    </div>
    `;
  }
  return productCard;
}
/* END */

let paginationBottom;
let paginationTop;

/* START: sets custom functionality for top set of pagination controls */
const setPaginationControls = () => {

  /** @type Element[] */
  const paginationBtns = qsa('#pagination-bottom li');

  paginationBtns.forEach(btn => {
    btn.addEventListener('click', function () {

      /** @type Number - current page number */
      const currentPageNumber = parseInt(btn.dataset.num);

      if (currentPageNumber) {
        const totalPages = paginationTop.pagination('getTotalPage');
        const prevButton = qs('#pagination-top .paginationjs-prev');
        const prevButtonAnchor = qs('a', prevButton);
        const nextButton = qs('#pagination-top .paginationjs-next');
        const nextButtonAnchor = qs('a', nextButton);

        qs('#pagination-top .paginationjs-page.active').classList.remove('active');
        qs(`#pagination-top .paginationjs-page[data-num="${currentPageNumber}"]`).classList.add('active');
        qs(`#pagination-top .paginationjs-page[data-num="${currentPageNumber}"] a`).removeAttribute('href')
        qsa('#pagination-top .paginationjs-page:not(.active) a').forEach(anchor => {
          anchor.setAttribute('href', "")
        })
        prevButton.dataset.num = currentPageNumber - 1;
        nextButton.dataset.num = currentPageNumber + 1;

        if (currentPageNumber === 1) {
          prevButton.classList.add('disabled');
          prevButton.classList.remove('J-paginationjs-previous');
          prevButton.removeAttribute('data-num');
          prevButtonAnchor.removeAttribute('href');
          nextButton.classList.remove('disabled');
          nextButton.classList.add('J-paginationjs-next');
          nextButtonAnchor.setAttribute('href', "");
        }

        if (currentPageNumber > 1) {
          prevButton.classList.remove('disabled');
          prevButton.classList.add('J-paginationjs-previous');
          prevButtonAnchor.setAttribute('href', "");
          nextButton.classList.remove('disabled');
          nextButton.classList.add('J-paginationjs-next');
          nextButtonAnchor.setAttribute('href', "");
        }

        if (currentPageNumber === totalPages) {
          nextButton.classList.add('disabled');
          nextButton.classList.remove('J-paginationjs-next');
          nextButton.removeAttribute('data-num');
          nextButtonAnchor.removeAttribute('href');
        }
      }
    })
  })
}
/* END */

/* START: sort function for index */
const productSortByIndex = (a, b) => {
  if (a.index < b.index) {
    return -1;
  } else if (a.index > b.index) {
    return 1;
  } else if (a.index === b.index) {
    return 0;
  }
}
/* END */


/* START: sort function for general index (index for when no filters selected) */
const productSortByGeneralIndex = (a, b) => {
  const generalIndexA = Number(a.generalIndex);
  const generalIndexB = Number(b.generalIndex);
  if (generalIndexA < generalIndexB) {
    return -1;
  } else if (generalIndexA > generalIndexB) {
    return 1;
  } else if (generalIndexA === generalIndexB) {
    return 0;
  }
}
/* END */


/* START: hide pagination controls if less than 2 pages of results */
const hidePagination = totalPages => {
  if (totalPages < 2) {
    paginationBottom.pagination('hide');
    paginationTop.pagination('hide');
  } else {
    paginationBottom.pagination('show');
    paginationTop.pagination('show');
  }
}
/* END */


/* START: function to render paginated product cards */
const renderProductCards = foundProducts => {
  let dataContainer = $j('.products');
  let dataContainerNoImage = $j('.products-no-image');

  const cardsPerPage = 100;
  const customClass = 'paginationjs-theme-zymo-green';

  paginationBottom = $j('#pagination-bottom').pagination({
    dataSource: foundProducts,
    pageSize: cardsPerPage,
    className: customClass,
    afterPaging: function (e) {
      setPaginationControls();
    },
    callback: function (foundProducts) {
      let html = '';
      for (let i = 0; i < foundProducts.length; i++) {
        html = html + cardTemplate(foundProducts[i]);
      }
      dataContainer.html(html);
      dataContainerNoImage.html(html);
    }
  });

  paginationTop = $j('#pagination-top').pagination({
    dataSource: foundProducts,
    pageSize: cardsPerPage,
    className: customClass,
    afterPaging: function (e) {
      paginationBottom.pagination('go', e)
    },
    callback: function (foundProducts) {
      let html = '';
      for (let i = 0; i < foundProducts.length; i++) {
        html = html + cardTemplate(foundProducts[i]);
      }
      dataContainer.html(html);
      dataContainerNoImage.html(html);
    }
  });

  const totalPages = paginationBottom.pagination('getTotalPage');

  hidePagination(totalPages);
}
/* END */


/* START: function to get data about found products */
/**
 * @param {String} filterArgs - all selected filters (excluding tags) concatenated into one string
 * @param {Object} tags - a Set of tags in string form
 * @returns {Object} An object consisting of found products, a list of possible filters that can be combined with selected filters,
 *  and a boolean to indicate whether to show all products in schema
*/
const getProducts = (filterArgs = null, tags = null, noRender = null) => {
  if (tags && tags.size === 0) {
    tags = null;
  }
  else if (tags && tags.size > 0) {
    tags = [...[...tags]]
  }

  /** @type Object[] - array to hold all found products that match selected filters and tags */
  let foundProducts = [];

  /** @type Boolean - boolean to indicate whether to show all products for when no filters or tags are selected */
  let showAll = false;

  /** @type Object - a Set containing all filters that could possibly be matched with currently selected filters/tags */
  let possibleFilters = new Set();

  /** @type Boolean - boolean to indicate if only one filter is selected */
  let oneFilterIsSelected;
  if (filterArgs) {
    oneFilterIsSelected = !filterArgs.includes('/');
  }

  /** @type Boolean */
  const nothingIsSelected = !filterArgs && !tags;
  /** @type Boolean */
  const onlyFiltersSelected = filterArgs && !tags;
  /** @type Boolean */
  const filtersAndTagsSelected = filterArgs && tags;
  /** @type Boolean */
  const onlyTagsSelected = !filterArgs && tags;


  /* If no filters or tags are selected, foundProducts will be all products in schema file and all products will show */
  if (nothingIsSelected) {
    foundProducts = Object.values(page_schema.products);
    showAll = true;
  }

  else {
    Object.values(page_schema.products).forEach(product => {

      /** @type Boolean - boolean to indicate whether product matches up with all selected tags */
      let tagsMatched;
      if (tags) {
        tagsMatched = tags.every(tag => product.tags.includes(tag));
      }

      if (onlyFiltersSelected || (filtersAndTagsSelected && tagsMatched)) {
        /* For each product, loop through product's array of filters */
        product.filters.forEach(filter => {
          /**
           * For each product filter, check if it matches with filters that have been selected
           * If so, set the matching product's index to the index that correlates with the product filter
           * Then add the product to the list of matching products and also add the product's tags to the list of possible filters, both to be returned
          */
          const filterName = Object.keys(filter)[0];
          if (filterName === filterArgs) {
            product.index = filter[filterArgs];
            foundProducts.push(product);
            possibleFilters = new Set([...possibleFilters, ...product.tags]);
          }

          /**
           * If only one filter is selected and the current filter pair contains the one selected filter, add the other filter in the pair to list of possible filters
           * Ex.) if "blood" is selected and current filter pair is "blood/trizol-samples", add "trizol-samples" to list of possible filters
          */

          /** @type Boolean */
          const currentFilterIsPair = filterName.includes('/');

          /** @type Boolean */
          const currentFilterContainsSelected = filterName.includes(filterArgs);

          if (oneFilterIsSelected && currentFilterIsPair && currentFilterContainsSelected) {
            const otherFilter = filterName.split('/').find(filter => filter !== filterArgs);
            possibleFilters.add(otherFilter);
          }
        })
      }

      else if (onlyTagsSelected && tagsMatched) {
        foundProducts.push(product);
        possibleFilters = new Set([...possibleFilters, ...product.tags]);

        product.filters.forEach(filter => {
          const filterName = Object.keys(filter)[0];
          if (!filterName.includes('/')) {
            possibleFilters.add(filterName);
          }
        })
      }
    })
  }

  /* If no filters or tags selected, sort all products by general index */
  if (nothingIsSelected || onlyTagsSelected) {
    foundProducts.sort(productSortByGeneralIndex);
  }
  /* If filter or tag is selected, sort products by index set when the product matched according to above conditions */
  else {
    foundProducts.sort(productSortByIndex);
  }

  if(noRender == null){
    renderProductCards(foundProducts);
  }


  return { foundProducts, possibleFilters, showAll };
}
/* END */

/* START: function to update view when filters are selected or un-selected */
const setView = (filterArgs, tags, animationCompleteCallbackFunction = null) => {
  const { foundProducts, possibleFilters, showAll } = getProducts(filterArgs, tags);
  hideFilters(possibleFilters, showAll, animationCompleteCallbackFunction);
  setProductCount(foundProducts.length);
}

function getProductCount(filterArgs, tags) {
  const { foundProducts, possibleFilters, showAll } = getProducts(filterArgs, tags, false);
  // hideFilters(possibleFilters, showAll, animationCompleteCallbackFunction);
  return foundProducts.length;
  // setProductCount(foundProducts.length);
}
/* END */

const setPills = (filters) => {
  countFilters();
  const pillContainer = qs('.filter-pills');
  pillContainer.textContent = '';

  let pills = '';

  filters.forEach(filter => {
    const label = qs(`label[for="${filter}"`).textContent;
    let pillCloseButton = ``;
    let hasCloseButton = true;
    if(typeof permaFilter !== 'undefined'){
      if( isPermaFilter(filter)){
        hasCloseButton = false
      }
    }
    if(hasCloseButton){
      pillCloseButton =  `<button onclick="onPillCancel(this)" class="filter-pill__cancel"> x </button>`

      const template = `
      <span class="${filter}">
        <span class="filter-pill-text">${label.replace(/ *\([^)]*\) */g, " ")}</span>
        ${pillCloseButton}
      </span>
      `;

      pills += template;
    }
  })

  pillContainer.insertAdjacentHTML('beforeend', pills);
}

window.addEventListener('load', () => {
  setPaginationControls();
  // const carets = qsa('.filter-grid .caretIcon');
  // carets.forEach(caret => {
  //   caret.addEventListener('click', () => {
  //     caret.classList.toggle('caretUp')
  //   })
  // })

  const subtierControllers = qsa('[data-subtier-controller]');
  subtierControllers.forEach(control => {
    const collapseEl = qs(`#${control.dataset.subtierController}`);
    control.addEventListener('click', () => {
      if (control.checked) {
        $j(collapseEl).slideDown({ duration: 300 })
      } else {
        $j(collapseEl).slideUp({ duration: 300 })
      }
    })
  })
})

/***** FUNCTIONALITY FOR MOBILE VIEW *****/
const classNames = ['.sliding-menu-icon', '.close-sliding-menu-icon', '.dark-background'];

classNames.forEach(className => {
  qs(className).addEventListener('click', () => {

    if ($j('.filter-grid form').css('display') === 'none') {
      $j('.filter-grid form').show("slide", { direction: "left" }, 300);
      $j('.dark-background').show();
    } else {
      $j('.filter-grid form').hide("slide", { direction: "left" }, 300);
      $j('.dark-background').hide();
    }
  })
})

const stickFilterBtn = () => {
  if (window.scrollY > 5) {
    qs('.filter-btn-container').classList.add('transparent-sticky');
  } else {
    qs('.filter-btn-container').classList.remove('transparent-sticky');
  }
}

let didScroll;
let checkScrollIntervalId;

window.addEventListener('scroll', () => { didScroll = true; });

checkScrollIntervalId = setInterval(() => {
  if (didScroll) {
    stickFilterBtn();
    didScroll = false;
  }
}, 250);
/***** END *****/

/***** SCRIPTS FOR HOTJAR *****/
const elementToObserve = qs("body");

const filterObserver = new MutationObserver(() => {
  const hjSurveyBranding = qs('[class*="surveyBranding"]');
  if (hjSurveyBranding) {
    setTimeout(() => {
      hjSurveyBranding.remove();
    }, 10);
    // filterObserver.disconnect();
  }
});

filterObserver.observe(elementToObserve, { subtree: true, childList: true });

window.addEventListener('load', () => {
  const inputs = qsa('.filter-grid form input');
  inputs.forEach(input => {
    input.addEventListener('click', () => {
      window.hj('event', 'clicked_filter');
    })
  })
});

$j(window).resize(function() {
  var viewportWidth = $(window).width();
  if(viewportWidth >= 1250){
    $j('.filter-grid form').show();
    $j('.dark-background').hide();
  }
  else{
    $j('.filter-grid form').hide();
    $j('.dark-background').hide();
  }
});

function scrollToTargetAdjusted(){
  var element = document.getElementById('filter-pills-container') ? document.getElementById('loaded-container') : document.getElementsByClassName('filter-message')[0]
  var headerOffset = Number(getComputedStyle(document.body).getPropertyValue('--header-height').replace('px','')) + 15;
  var elementPosition = element.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

  window.scrollTo({
       top: offsetPosition,
       behavior: "smooth"
  });
}

function countFilters(){
  for(tier in page_schema.tiers){
    let filterCount = 0;
    for(option in page_schema.tiers[tier].options){
        if(filters.tags.has(page_schema.tiers[tier].options[option].id)){

          if(typeof permaFilter !== 'undefined'){
            if(permaFilter.split(',').indexOf(page_schema.tiers[tier].options[option].id) < 0 ){
              filterCount++;
            }
          }
          else{
            filterCount++;
          }
        }
    }
    if( filterCount > 0){
      document.getElementById(page_schema.tiers[tier].id+'-count').innerHTML = '(' + filterCount + ')'
      document.getElementById(page_schema.tiers[tier].id+'-container-button').classList.add("header-container-selected")
    }
    else{
      document.getElementById(page_schema.tiers[tier].id+'-count').innerHTML = ''
      document.getElementById(page_schema.tiers[tier].id+'-container-button').classList.remove("header-container-selected")
    }
}
}

/***** END *****/